const AtivoEnum = {
    SIM: 'Sim',
    NAO: 'Nao'
}

export default AtivoEnum;